<template>
  <div class="home-content">
    <!-- <div class="home-c-msg">
        <p>CMEF（全称：中国国际医疗器械博览会）始创于1979年，每年举办春秋两届，包括展览和论坛两个部分。展会历经40余年的积累和沉淀，现已发展成为国际领先的覆盖医疗器械全产业链、集产品技术、新品首发、采购贸易、品牌传播、科研合作、学术论坛、教育培训为一体的全球化综合服务平台。</p>
    </div>-->
    <!-- <div class="home-c-type">
      <div class="home-c-type-li" v-for="(item,index) in entranceList" :key="index">
        <h3 class="title">{{item.name}}</h3>
        <p>{{item.description}}</p>
        <span @click="goUrl(item)">{{item.linkName}}</span>
      </div>
    </div> -->
    <div class="home-c-pro" v-if="kindList && kindList.length > 0">
      <h3>
        <span class="h3-l">热搜产品</span>
        <span class="h3-r" @click="linkTo('pro')">MORE</span>
      </h3>
      <div class="pro-list">
        <div class="pro-list-li" v-for="(item,index) in kindList" :key="index">
          <div class="li-left">
            <h2>{{index+1}}F</h2>
            <h4 :title="item.webKind.name">{{item.webKind.name}}</h4>
          </div>
          <div class="li-right">
            <div
              class="li-one"
              v-for="(itm,idx) in item.products"
              :key="idx"
              @click="linkToPro(itm)"
            >
              <h4 :title="itm.name" v-if="itm.name">{{itm.name}}</h4>
              <p :title="itm.compName" v-if="itm.compName">{{itm.compName}}</p>
              <div class="one-img">
                <img :src="itm.banner[0]" v-if="itm.banner[0]" />
                <img src="@assets/img/empty.png" v-else />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="flag" style="width:100%;line-height:46px;background:#054e8c;text-align:center;font-size:22px;color:#fff;cursor:pointer;" @click="loadMore()">MORE</div>
    </div>

    <!-- 云发布、云课 -->
    <div class="home-cloud" v-if="marathonList && marathonList.length > 0">
      <div v-for="(item,index) in marathonList" :key="index">
        <div class="cloud-top">
          <div class="cloud-top-txt">
            <h3 style="cursor:pointer;" @click="goMarathon(item.nameUrl)">{{item.name}}</h3>
            <p v-html="item.remark" style="line-height:1.5;"></p>
            <div class="p-last" v-if="item.linkText">
              <p @click="goMarathon(item.linkUrl)">{{item.linkText}}<span></span></p>
              <i class="icon iconfont icon-xiangshang"></i>
            </div>
          </div>
          <img v-for="(itm,idx) in item.imgSet" :key="idx" :src="itm.ImgUrl" @click="goMarathon(itm.LinkUrl)" style="cursor:pointer;" />
        </div>
        <img v-if="index !== marathonList.length - 1" src="@assets/img/cloud-line.png" />
      </div>
    </div>

    <!-- <div class="home-c-brand">
      <h3>推荐展商</h3>
      <brandCard></brandCard>
    </div> -->
    <!-- <div class="home-c-review" v-if="planList.length">
      <h3>CMEF系列展会计划</h3>
      <div class="re-li">
        <div class="re-li-item" v-for="(item, index) in planList" :key="'planList-' + index">
          <i class="brand"></i>{{item.name}}{{ '-' + item.time}}
        </div> 
      </div>
      <span @click="handle">展位预定</span>
    </div> -->
    <!-- 展会预览 -->
    <!-- <div class="home-c-plan" v-if="planList.length">
      <h3>展会预览</h3>
      <div style="background-color:#fafafa;display:flex;">
        <img src="@assets/img/expreview.png" style="width:825px;height:540px;" />
        <div>
          <div class="plan-list" v-for="(item,index) in planList" :key="index" @click="link(item)" v-if="index < 4">
            <div style="width:100%;height:50%;display:flex;padding-top:20px;">
              <img v-if="item.cover" :src="item.cover" />
              <div class="list-text">
                <p class="t">时间：{{item.time}}</p>
                <p class="t">地点：{{item.address}}</p>
              </div>
            </div>
            <h1 :title="item.name">{{item.name}}</h1>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 修改后的展会预览 -->
    <!-- <div class="home-c-plan">
      <h3>展会预览</h3>
      <div style="background-color:#fafafa;display:flex;height:540px;">
        <img v-if="plan1 === 0" src="@assets/img/CMEF.jpg" style="width:825px;height:540px;" />
        <img v-if="plan1 === 1" src="@assets/img/ICMD.jpg" style="width:825px;height:540px;" />
        <img v-if="plan1 === 2" src="@assets/img/IN.jpg" style="width:825px;height:540px;" />
        <img v-if="plan1 === 3" src="@assets/img/REHABSHOW.jpg" style="width:825px;height:540px;" />
        <div>
          <div class="plan-list" :class="plan1 === 0?'pActive':''" @mouseenter="plan1=0;planEnter=false;" @mouseleave="planEnter=true;">
            <div style="width:100%;height:76px;display:flex;padding:20px 0 5px;align-items:center;">
              <img src="@assets/img/logo-cmef.png" />
              <div class="list-text">
                <p class="t">时间：2020年10月19-22日</p>
                <p class="t">地点：国家会展中心（上海）</p>
              </div>
            </div>
            <h1 style="margin-top:16px;" @click="linkToOut(0)">中国国际医疗器械博览会</h1>
          </div>
          <div class="plan-list" :class="plan1 === 1?'pActive':''" @mouseenter="plan1=1;planEnter=false;" @mouseleave="planEnter=true;">
            <div style="width:100%;height:76px;display:flex;padding:20px 0 5px;align-items:center;">
              <img style="width:108px;height:59px;" src="@assets/img/logo-icmd.png" />
              <div class="list-text">
                <p class="t">时间：2020年10月19-22日</p>
                <p class="t">地点：国家会展中心（上海）</p>
              </div>
            </div>
            <h1 style="margin-top:16px;" @click="linkToOut(1)">中国国际医疗器械设计与制造技术博览会</h1>
          </div>
          <div class="plan-list" :class="plan1 === 2?'pActive':''" @mouseenter="plan1=2;planEnter=false;" @mouseleave="planEnter=true;">
            <div style="width:100%;height:76px;display:flex;padding:20px 0 5px;align-items:center;">
              <img style="width:115px;height:37px;" src="@assets/img/logo-in.png" />
              <div class="list-text">
                <p class="t">时间：2020年10月19-22日</p>
                <p class="t">地点：国家会展中心（上海）</p>
              </div>
            </div>
            <h1 style="margin-top:16px;" @click="linkToOut(2)">国际智慧健康展</h1>
          </div>
          <div class="plan-list" :class="plan1 === 3?'pActive':''" @mouseenter="plan1=3;planEnter=false;" @mouseleave="planEnter=true;">
            <div style="width:100%;height:76px;display:flex;padding:10px 0 5px;align-items:center;">
              <img style="width:113px;height:24px;" src="@assets/img/logo-res.png" />
              <div class="list-text">
                <p class="t">时间：2020年10月19-22日</p>
                <p class="t">地点：国家会展中心（上海）</p>
              </div>
            </div>
            <h1 style="margin-top:0;" @click="linkToOut(3)">国际康复及个人健康博览会暨国际养老福祉及护理用品博览会</h1>
          </div>
        </div>
      </div>
    </div> -->

    <div class="home-c-plan" v-if="planList && planList.length">
      <h3>展会预览</h3>
      <div style="background-color:#fafafa;display:flex;height:540px;">
        <img v-if="planUrl[plan1] !== 'noCover'" :src="planUrl[plan1]" style="width:825px;height:540px;" />
        <img v-else src="@assets/img/empty.png" style="width:825px;height:540px;" />
        
        <div>
          <div v-for="(item,index) in planList" :key="index" class="plan-list" :class="plan1 === index?'pActive':''" @mouseenter="plan1=index;planEnter=false;" @mouseleave="planEnter=true;">
            <div style="width:100%;height:76px;display:flex;padding:20px 0 5px;align-items:center;">
              <img v-if="item.logo" :src="item.logo" />
              <img v-else src="@assets/img/empty.png" />
              <div class="list-text">
                <p class="t">时间：{{item.time}}</p>
                <p class="t">地点：{{item.address}}</p>
              </div>
            </div>
            <h1 style="margin-top:5px;" @click="choose(item)">{{item.name}}</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="home-c-model" v-if="show">
      <div
        class="model-l"
      >We use cookies to help provide you with the best possible online experience. Please read our Privacy Policy and Cookie Policy for information about which cookies we use and what information we collect on our site. By continuing to use this site, you agree that we may store and access cookies on your device.</div>
      <div class="model-r" @click="setAgree()">I AGREE</div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import brandCard from "@components/homeC/brand-card.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "home",
  data() {
    return {
      show: false, // 分页
      PageIndex: 1, // 分页
      PageSize: 8, // 默认50个一页
      Total: 0,
      condition: [],
      donetTip: false,
      proList: [],
      planList: [],
      entranceList: [],
      kindList: [],
      kindListReal: [],
      top: 4,
      flag: false,
      
      plan1: 0,
      planEnter: true,
      plTimer: null,
      planUrl: [],
      marathonList: []
    };
  },
  components: {
    brandCard,
    swiper,
    swiperSlide
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId"
    })
  },
  created() {
    // this.getEntrance();
    this.getProList();
    this.showAgree();
    this.getPlan();
    this.getKind();
    this.getMarathonInfo();
  },
  methods: {
    ...mapActions({
      getExhibitionPlan: "exhibitor/getExhibitionPlan",
      getProduct: "home/getProduct",
      getQuickEntrance: "home/getQuickEntrance",
      getWebKind: "home/getWebKind",
      getMarathon: "getMarathon"
    }),
    async getMarathonInfo() {
      let list = await this.getMarathon();
      if (list && list.length > 0) {
        list.map(c => {
          c.imgSet = JSON.parse(c.imgSet);
          c.imgSetEn = JSON.parse(c.imgSetEn);
          c.remark = c.remark.replace(/\n/g,"<br/>");
        })
      }
      this.marathonList = list;
    },
    async getProList() {
      let opt = {
        body: {
          pageSize: this.PageSize,
          pageIndex: this.PageIndex,
          ExhibitionId: this.exhibitionId
        },
        topic: -1,
        apply: 0
      };
      console.log("请求产品的opt:", opt);
      let result = await this.$service.getProduct(this, opt);
      console.log(result, "mania");
      // this.proList = result;
    },
    async getKind() {
      let kindList = await this.getWebKind({
        // top: this.top,
        top: 1000,
        productCount: 4
      });
      if (kindList && kindList.length > 0) {
        kindList.map(c => {
          c.products.map(d => {
            d.banner = JSON.parse(d.banner);
          })
        })
        if (kindList.length > 3) {
          this.kindListReal = kindList;
          this.kindList = kindList.slice(0,3);
          this.flag = true;
        } else {
          this.kindList = kindList;
        }
      }
      console.log("KIND：",kindList)
    },
    loadMore() {
      this.flag = false;
      this.kindList = this.kindListReal;
    },
    loadList() {
      this.PageIndex = this.PageIndex + 1;
      this.getProList();
    },
    linkToPro(item) {
      let url = this.$router.resolve({
        path: "/pro-details/" + item.id,
        query: {
          compId: item.compId
        }
      });
      window.open(url.href, '_blank');
    },
    linkTo(type) {
      switch (type) {
        case "pro":
          this.$router.push(`/ex-list`);
          break;
        case "chance":
          this.$router.push(`/chance`);
          break;
        case "live":
          this.$router.push(`/ex-list`);
          break;
        case "act":
          this.$router.push(`/act-list`);
          break;
      }
    },
    async getPlan() {
      let list = await this.getExhibitionPlan();
      if (list && list.length > 0) {
        list.map(c => {
          if (c.cover) {
            this.planUrl.push(c.cover);
          } else {
            this.planUrl.push("noCover");
          }
        })
        this.planList = list;
      } else {
        this.planList = [];
        this.planUrl = [];
      }
    },
    async getEntrance() {
      let list = await this.getQuickEntrance();
      this.entranceList = list;
    },
    setAgree() {
      this.$cookies.set("agreeCookies", "true", -1);
      this.showAgree();
    },
    showAgree() {
      const bool = this.$cookies.get("agreeCookies");
      if (!bool) {
        this.show = true;
      } else {
        this.show = false;
      }
      console.log("bool:", bool);
    },
    handle() {
      this.$Message.warning("暂未开放！");
    },
    goUrl(item) {
      if (item.link) {
        window.open(item.link,'_blank');
      }
    },
    link(item) {
      if (item.link) {
        window.open(item.link,'_blank');
      }
    },
    choose(e) {
      if (e.exLink) {
        window.open(e.exLink,'_blank');
      }
    },
    linkToOut(e) {
      if (e === 0) {
        window.open('https://www.cmef.com.cn/','_blank');
      }
      if (e === 1) {
        window.open('http://www.icmd.com.cn/','_blank');
      }
      if (e === 2) {
        window.open('https://www.cmef.com.cn/g1180.aspx','_blank');
      }
      if (e === 3) {
        window.open('http://www.rehabshow.com.cn/','_blank');
      }
    },
    goM() {
      window.open('https://marathon.cmef.com.cn','_blank');
    },
    goMarathon(e) {
      if (e) {
        window.open(e,'_blank');
      }
    },
    // goXET() {
    //   window.open('https://live.cmef.com.cn/page/945162','_blank');
    // },
    goM1() {
      window.open('https://live.cmef.com.cn/detail/p_5e675a9daee49_UeOO5zGV/6','_blank');
    },
    goM2() {
      window.open('https://live.cmef.com.cn/detail/p_5e68567cb68a3_s8I1MLv8/6','_blank');
    },
    goM3() {
      window.open('https://live.cmef.com.cn/detail/p_5e6859683eb82_xSBslWeD/6','_blank');
    },
    goMeeting1() {
      window.open('https://app3lXzCNgW9132.h5.xeknow.com/st/1gz3XfAsY','_blank');
    },
    goMeeting2() {
      window.open('https://app3lXzCNgW9132.h5.xeknow.com/st/8jmQXN2ud','_blank');
    },
    goMeeting3() {
      window.open('https://app3lXzCNgW9132.h5.xeknow.com/st/5VLXepZ70','_blank');
    },
  },
  mounted() {
    this.plTimer = setInterval(() => {
      if (!this.planEnter) {
        return;
      }
      if (this.plan1 >=this.planList.length - 1) {
        this.plan1 = 0;
      } else {
        this.plan1++;
      }
    }, 3000)
  },
  destroyed() {
    // console.log("销毁定时器");
    clearInterval(this.plTimer);
  }
};
</script>

<style scoped lang="scss">
@import "@assets/scss/utils.scss";
.home-content {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  padding-bottom: 120px;
}
.home-c {
  &-msg {
    padding-top: 10px;
    p {
      font-size: 16px;
      line-height: 30px;
      color: #333;
      text-indent: 32px;
    }
  }
  &-type {
    display: flex;
    justify-content: space-around;
    // margin-top: 50px;
    &-li:hover {
      background: #024c8b;
      transition: all 0.3s;
      h3,
      p {
        color: #fff;
      }
      span {
        background: #fff;
        color: #006fb4;
      }
    }
    &-li {
      width: 25%;
      text-align: center;
      padding: 26px 0 40px;
      transition: all 0.3s;
      h3 {
        font-size: 24px;
        font-weight: bold;
        line-height: 30px;
        color: #b1262d;
        margin-bottom: 30px;
      }
      p {
        width: 86%;
        text-align: justify;
        margin: 0 auto;
        font-size: 16px;
        line-height: 30px;
        height: 180px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        overflow: hidden;
      }
      span {
        display: inline-block;
        width: 200px;
        height: 48px;
        background-color: #024c8b;
        font-size: 16px;
        color: #fff;
        line-height: 48px;
        text-align: center;
        margin-top: 30px;
        cursor: pointer;
      }
      // span:hover{
      //   background-color: #006fb4;
      // }
    }
  }
  &-brand {
    h3 {
      font-size: 24px;
      font-weight: bold;
      line-height: 26px;
      color: #024c8b;
      text-align: center;
      margin: 56px 0 28px;
    }
  }
  &-plan {
    h3 {
      width: 100%;
      font-size: 16px;
      font-weight: normal;
      line-height: 48px;
      color: #fff;
      text-align: center;
      margin-top: 50px;
      background-color: #054e8c;
    }
    .plan-list {
      width: 375px;
      height: 135px;
      padding: 0 20px;
      border-bottom: 1px solid #ebeef3;
      &:hover {
        cursor: pointer;
        border-right: 4px solid #054e8c;
        background-color: #fff;
        h1 {
          color: #024c8b;
        }
        .t {
          color: #024c8b;
        }
      }
      img {
        width: 112px;
        height: 36px;
      }
      .list-text {
        width: calc(100% - 140px);
        height: 100%;
        display: flex;
        flex-direction: column;
        color: #333;
        justify-content: space-around;
        margin-left: 20px;
        p {
          font-size: 14px;
          line-height: 24px;
          color: #666;
        }
        .t {
          width: 100%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      h1 {
        text-align: left;
        width: 100%;
        font-size: 18px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin-top: 12px;
        color: #333;
        font-weight: normal;
        line-height: 1.4;
      }
    }
    .pActive {
      cursor: pointer;
      border-right: 4px solid #054e8c;
      background-color: #fff;
    }
  }
  &-review {
    width: 100%;
    background-color: #024c8b;
    padding: 30px 30px 17px 30px;
    color: #fff;
    margin-top: 50px;
    h3 {
      font-size: 24px;
      font-weight: bold;
      line-height: 26px;
      padding-bottom: 26px;
      text-align: center;
    }
    p {
      font-size: 16px;
      line-height: 30px;
      text-align: justify;
      text-indent: 32px;
    }
    .re-li {
      display: flex;
      flex-wrap: wrap;
      &-item {
        padding-left: 156px;
        width: 50%;
        font-size: 20px;
        line-height: 30px;
        color: #fff;
        padding-bottom: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .brand {
          display: inline-block;
          width: 6px;
          height: 6px;
          margin-right: 10px;
          background-color: #fff;
          border-radius: 50%;
          position: relative;
          position: relative;
          top: -4px;
        }
      }
    }
    ul:last-child {
      padding-left: 270px;
    }
    span {
      display: block;
      width: 200px;
      height: 48px;
      background-color: #fff;
      font-size: 16px;
      line-height: 48px;
      color: #024c8b;
      text-align: center;
      margin: auto;
      cursor: pointer;
    }
  }
  &-pro {
    margin-top: 50px;
    h3 {
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid #054e8c;
      .h3-l {
        width: 120px;
        height: 40px;
        background-color: #024c8b;
        display: inline-block;
        font-size: 20px;
        font-weight: normal;
        line-height: 40px;
        color: #fff;
        text-align: center;
        position: relative;
      }
      .h3-l::after {
        content: "";
        display: block;
        width: 40px;
        height: 40px;
        background-color: #054e8c;
        opacity: 0.3;
        position: absolute;
        right: -4px;
        top: -4px;
      }
      .h3-r {
        font-size: 22px;
        font-weight: normal;
        line-height: 40px;
        color: #024c8b;
        cursor: pointer;
      }
      .h3-r:hover {
        color: #006fb4;
      }
    }
    .pro-bot {
      display: flex;
      .pro-left {
        width: 250px;
        height: 540px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    &-li {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      .li-one {
        width: 236px;
        height: 268px;
        margin: 0 2px 2px 0;
        background: #fff;
        padding: 12px;
        h4,
        p {
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }
        h4 {
          font-size: 16px;
          font-weight: normal;
          line-height: 18px;
          margin: 16px 0 8px;
        }
        p {
          font-size: 12px;
          line-height: 14px;
        }
        .one-img {
          margin-top: 26px;
          width: 100%;
          height: 142px;
          position: relative;
          img {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            margin: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
      .li-one:nth-child(4n + 4) {
        margin-right: 0;
      }
    }
  }
  &-model {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -22px;
    width: 688px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding: 25px 14px;
    background-color: #f5f5f5;
    box-shadow: 0px 0px 30px 0px rgba(102, 102, 102, 0.15);
    .model-l {
      flex: 1;
      font-size: 14px;
      font-weight: normal;
      line-height: 18px;
      color: #000;
    }
    .model-r {
      width: 76px;
      height: 26px;
      background-color: #024c8b;
      margin-left: 24px;
      text-align: center;
      line-height: 26px;
      font-size: 14px;
      font-weight: normal;
      color: #fff;
      cursor: pointer;
    }
    .model-r:hover {
      background-color: #006fb4;
    }
  }
}
.home-right {
  flex: 1;
  .brand-ex {
    background-color: #fff;
    padding: 20px;
  }
  .right-title {
    display: flex;
    justify-content: space-between;
    .right-sp {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      color: #333;
      i {
        width: 4px;
        height: 16px;
        background-color: #0190fe;
        margin-right: 10px;
      }
    }
    .title-more {
      font-size: 14px;
      color: #333;
    }
  }
  .pro-list,
  .act-list {
    background-color: #fff;
    padding: 20px;
    margin-top: 20px;
  }
  .all-act {
    display: flex;
  }
  .act-list-one {
    width: 25%;
    height: 200px;
    display: inline-block;
    img {
      width: 195px;
      height: 135px;
    }
  }
}
.home-follow {
  margin-top: 20px;
  padding: 20px 20px 6px;
  .follow-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    span {
      display: inline-block;
      width: 20%;
      height: 40px;
      border-radius: 50%;
      margin-bottom: 14px;
      img {
        width: 40px;
        height: 100%;
        border-radius: 50%;
        margin: 0 auto;
      }
    }
  }
}
.home-two-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .list-one {
    width: 384px;
  }
}
.home-new-list {
  h2 {
    font-size: 22px;
    font-weight: bold;
    color: #333;
    text-align: center;
    span {
      display: inline-block;
      width: 22px;
      height: 16px;
    }
    span:first-child {
      background: url("../../../../assets/img/def_l.png");
    }
    span:last-child {
      background: url("../../../../assets/img/def_r.png");
    }
  }
}
.home-brand-list {
  width: 100%;
  height: 200px;
  background-color: #fff;
  // box-shadow: 0px 0px 30px 0px
  // 	rgba(102, 102, 102, 0.15);
  padding: 15px 0;
}
.home-tj {
  h2 {
    line-height: 64px;
    margin: 20px 0;
    background: #fff;
  }
}
.product {
  width: 1200px;
  position: relative;
  @include clearfix;
  @include empty-txt(400px, "暂无数据");
}
.product .wrap {
  margin-right: 20px;
}
.product .wrap:nth-of-type(4n) {
  margin-right: 0;
}
.more {
  height: 80px;
  text-align: center;
}
.more span {
  color: #040000;
  font-size: 14px;
  cursor: pointer;
  line-height: 80px;
}
.pro-list {
  &-li {
    display: flex;
    margin-bottom: 10px;
    .li-left {
      width: 238px;
      height: 268px;
      margin: 0 2px 2px 0;
      background: #fff;
      padding: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      h2,
      h4 {
        font-size: 30px;
        font-weight: normal;
        line-height: 60px;
        letter-spacing: 0px;
        color: #054e8c;
        text-align: center;
      }
      h4 {
        width: 100%;
        line-height: 34px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .li-right {
      display: flex;
      .li-one {
        width: 238px;
        height: 268px;
        margin: 0 2px 2px 0;
        background: #fff;
        padding: 12px;
        cursor: pointer;
        transition: 0.2s;
        &:hover {
          transform: scale(1.1);
        }
        h4,
        p {
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }
        h4 {
          font-size: 16px;
          font-weight: normal;
          line-height: 18px;
          margin: 16px 0 8px;
        }
        p {
          font-size: 12px;
          line-height: 14px;
        }
        .one-img {
          margin-top: 26px;
          width: 100%;
          height: 142px;
          position: relative;
          img {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            margin: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
      .li-one:nth-child(4n + 4) {
        margin-right: 0;
        width: 239px;
      }
    }
  }
}
.home-c-model {
  position: fixed;
  left: 0;
  z-index: 10;
  right: 0;
  bottom: -22px;
  width: 688px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 25px 14px;
  background-color: #f5f5f5;
  box-shadow: 0px 0px 30px 0px rgba(102, 102, 102, 0.3);
  .model-l {
    flex: 1;
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
    color: #000;
  }
  .model-r {
    width: 76px;
    height: 26px;
    background-color: #024c8b;
    margin-left: 24px;
    text-align: center;
    line-height: 26px;
    font-size: 14px;
    font-weight: normal;
    color: #fff;
    cursor: pointer;
  }
  .model-r:hover {
    background-color: #006fb4;
  }
}
.home-cloud {
  border-top: 2px solid #054e8c;
  margin: 50px 0;
  background-color: #fff;
  .cloud-top {
    height: 265px;
    padding: 30px 0 30px 30px;
    &-txt {
      float: left;
      width: 260px;
      height: 100%;
      h3 {
        font-size: 24px;
        color: #333;
        line-height: 24px;
        margin: 22px 0;
      }
      p {
        font-size: 14px;
        color: #333;
        line-height: 1;
        margin-bottom: 10px;
      }
      .p-last {
        display: flex;
        align-items: center;
        p {
          margin-bottom: 0;
          margin-right: 10px;
          position: relative;
          padding-bottom: 8px;
          cursor: pointer;
          span {
            display: inline-block;
            width: 100%;
            height: 2px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #024c8b;
          }
        }
        i {
          line-height: 1;
          border: 1px solid #024c8b;
          border-radius: 50%;
          transform: rotate(90deg);
          color: #024c8b;
        }
      }
    }
    img {
      width: 280px;
      height: 210px;
      float: left;
      margin-right: 20px;
    }
  }
  .cloud-bottom {
    height: 265px;
    padding: 30px 0 30px 30px;
    &-txt {
      float: left;
      width: 260px;
      height: 100%;
      h3 {
        font-size: 24px;
        color: #333;
        line-height: 24px;
        margin: 50px 0 22px 0;
        cursor: pointer;
        width: 120px;
      }
      p {
        font-size: 14px;
        color: #333;
        line-height: 1;
        margin-bottom: 10px;
      }
    }
    img {
      width: 280px;
      height: 210px;
      float: left;
      margin-right: 20px;
      cursor: pointer;
    }
  }
}
// .swiper-container {
//   width: 100%;
//   height: 100%;
//   margin-left: auto;
//   margin-right: auto;
// }
</style>
